












import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'BaseSpinner'
})
export default class BaseSpinner extends Vue {
}
